import React from 'react';

export const Button = ({ 
  type = 'button', 
  variant = 'default', 
  onClick, 
  children, 
  className = '',
  disabled = false
}) => {
  const variantClasses = {
    default: 'btn-primary',
    outline: 'btn-outline',
    secondary: 'btn-secondary'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn ${variantClasses[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

export const RoundButtonS = ({
  onClick,
  children,
  className = '',
  title,
  ariaLabel,
}) => (
  <button
    type="button"
    className={`round-btn-s ${className}`}
    onClick={onClick}
    title={title}
    aria-label={ariaLabel ?? title}
  >
    {children}
  </button>
);

export const IconLeftButtonS = ({
  className = '',
  onClick,
  ariaLabel,
  icon,
  label,
}) => (
  <button
    type="button"
    className={`btn btn-s${className ? ` ${className}` : ''}`}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    {icon}
    <span>{label}</span>
  </button>
);

export const IconLeftButtonM = ({
  className = '',
  onClick,
  ariaLabel,
  icon,
  label,
}) => (
  <button
    type="button"
    className={`btn btn-m${className ? ` ${className}` : ''}`}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    {icon}
    <span>{label}</span>
  </button>
);
